import React, { useId } from "react";

export default function DynamicMethodSection({ data }) {
  const titleId = useId();

  if (!data?.steps?.length) return null;

  return (
    <section id="dynamic-method" className="dynamic-method-section" aria-labelledby={titleId}>
      <div className="container">
        <div className="row align-items-end dynamic-method-heading">
          <div className="col-lg-8">
            <span className="main-title">{data.eyebrow}</span>
            <h2 className="heading" id={titleId}>{data.title}<br />{data.titleSecondLine}</h2>
          </div>
          <div className="col-lg-4 dynamic-method-action">
            <a className="default-btn" href={data.buttonLink}>{data.buttonText}</a>
          </div>
        </div>
        <ol className="dynamic-method-steps">
          {data.steps.map((step, index) => (
            <li className="dynamic-method-step" key={step.title}>
              <span className="dynamic-method-number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
